import { render, staticRenderFns } from "./GroupLevelAttributeTrainerField.vue?vue&type=template&id=570fab52&"
import script from "./GroupLevelAttributeTrainerField.vue?vue&type=script&lang=ts&"
export * from "./GroupLevelAttributeTrainerField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports